export const OUTFIT_QUICK_VIEW_MODAL_TREATMENT = 1;
export const OUTFIT_STL_MODAL_TREATMENT = 2;
export const MSA_IMAGE_DIMENSIONS = { width: 400, height: 400 };
export const OUTFIT_RECO_REF_TAG = 'outfit-reco';
